import React, { useEffect, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import '@syncfusion/ej2-base/styles/material.css';       // Base styles including icons
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-react-schedule/styles/material.css';
import { loadScript } from "../Helpers/utils/loadScript";
import WebsiteAnalytics from "../Pages/WebsiteAnalytics/WebsiteAnalytics";

const AdminNewDashboard = lazy(() =>import("../Pages/AdminNew/index"));
const PublishedCoursesAdmin = lazy(() => import("../Pages/AdminNew/publishedCourses/publishedCourses"));
const ViewCourseAdmin = lazy(() => import("../Pages/AdminNew/publishedCourses/ViewCourse"));
const EditCourseAdmin = lazy(() => import("../Pages/AdminNew/publishedCourses/EditCourse"));
const CreateCourseAdmin = lazy(() => import("../Pages/AdminNew/AddCourse/CreateCourse"));
const ManagePartnersAdmin = lazy(() => import("../Pages/AdminNew/ManagePartners/ManagePartners"));
const DelegateManagements = lazy(() => import("../Pages/AdminNew/ManagePartners/DelegateManagements"));
const AllDelegateInstitutes = lazy(() => import("../Pages/AdminNew/ManagePartners/AllDelegateInstitutes"));
const ViewInstituteDetails = lazy(() => import("../Pages/AdminNew/ManagePartners/ViewInstituteDetails"));
const ApprovedInstitute = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/ApprovedInstitute"));
const InstituteData = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/InstituteData"));
const RequestPlan = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/RequestPlan"));
const PackagesAndPlan = lazy(() => import("../Pages/AdminNew/PackagesAndPlan/PackagesAndPlan"));
const Packages = lazy(() => import("../Pages/AdminNew/ManagePackages/Packages"));
const ClassRecordings = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/ClassRecordings"));
const ViewTeamMember = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/ViewTeamMember"));
const TrainingLearner = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/TrainingLearner"));
const InstituteCourses = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/InstituteCourses"));
const InstituteVehicles = lazy(() => import("../Pages/AdminNew/ManagePartners/ApprovedInstitute/InstituteVehicles"));
const ManageTeam = lazy(() => import("../Pages/AdminNew/ManageTeam"));
const ManageLearner = lazy(() => import("../Pages/AdminNew/ManageLearner/ManageLearner"));
const EnrollLearner = lazy(() => import("../Pages/AdminNew/ManageLearner/EnrollLearner"));
const ManageSchedule = lazy(() => import("../Pages/AdminNew/ManageLearner/ManageSchedule"));
const CourseStarting = lazy(() => import("../Pages/AdminNew/ManageLearner/CourseStarting"));
const PendingActivationDetail = lazy(() => import("../Pages/AdminNew/ManageLearner/PendingActivation/PendingActivationDetail"));
const Etransfer = lazy(() => import("../Pages/AdminNew/ETransfer/Etransfer"));
const DiscountManagement = lazy(() => import("../Pages/AdminNew/DiscountManagement/DiscountManagement"));
const ViewRecord = lazy(() => import("../Pages/AdminNew/ETransfer/ViewRecord"));
const VLIBlogManagement = lazy(() => import("../Pages/AdminNew/VLIBlogManagement/VLIBlogManagement"));
const CreateVLIBlogs = lazy(() => import("../Pages/AdminNew/CreateVLIBlogs/CreateVLIBlogs"));
const ViewVLIBlogs = lazy(() => import("../Pages/ViewVLIBlogs/ViewVLIBlogs"));
const UpdateCourseAdmin = lazy(() => import("../Pages/Admin/Add Course (VLI Admin)/UpdateCourseAdmn"));
const AddCourseAdmin = lazy(() => import("../Pages/Admin/Add Course (VLI Admin)/AddCourseAdmin"));
const AddBookAdmin = lazy(() => import("../Pages/Admin/Add Book (VLI Admin)/AddBookAdmin"));
const EbookList = lazy(() => import("../Pages/Admin/E-Book list/EbookList"));
const ManageStatusChild = lazy(() => import("../Pages/table/ManageStatus"));

// ✅ No <Routes> wrapper — returns Fragment so it works inside App.jsx's single <Routes>
const VLIAdminRoutes = () => (
  <React.Fragment>
    <Route path="/admin/dashboard" element={<AdminNewDashboard />} />
    <Route path="/admin/published-courses" element={<PublishedCoursesAdmin />} />
    <Route path="/admin/published-courses/view/:CoursePK" element={<ViewCourseAdmin />} />
    <Route path="/admin/published-courses/edit/:CoursePK" element={<EditCourseAdmin />} />
    <Route path="/admin/course/create" element={<CreateCourseAdmin />} />
    <Route path="/admin/manage-partners" element={<ManagePartnersAdmin />} />
    <Route path="/admin/delegate-institute-management" element={<AllDelegateInstitutes />} />
    <Route path="/admin/delegate-management" element={<DelegateManagements />} />
    <Route path="/admin/manage-partners/view/:InstituteId" element={<ViewInstituteDetails />} />
    <Route path="/admin/manage-partners/approved/:instituteId" element={<ApprovedInstitute />} />
    <Route path="/admin/manage-partners/approved/:instituteId/institute-data" element={<InstituteData />} />
    <Route path="/admin/manage-partners/approved/:instituteId/request-plan" element={<RequestPlan />} />
    <Route path="/admin/manage-partners/approved/:instituteId/class-recordings" element={<ClassRecordings />} />
    <Route path="/admin/manage-partners/approved/:instituteId/view-team-member" element={<ViewTeamMember />} />
    <Route path="/admin/manage-partners/approved/:instituteId/training-learner" element={<TrainingLearner />} />
    <Route path="/admin/manage-partners/approved/:instituteId/institute-courses" element={<InstituteCourses />} />
    <Route path="/admin/manage-partners/approved/:instituteId/institute-vehicles" element={<InstituteVehicles />} />
    <Route path="/admin/discount-management" element={<DiscountManagement />} />
    <Route path="/admin/packages-and-plan" element={<PackagesAndPlan />} />
    <Route path="/admin/manage-packages" element={<Packages />} />
    <Route path="/admin/manage-team" element={<ManageTeam />} />
    <Route path="/admin/manage-learners" element={<ManageLearner />} />
    <Route path="/admin/manage-learner/pendingactivation" element={<PendingActivationDetail />} />
    <Route path="/admin/enroll-learner" element={<EnrollLearner />} />
    <Route path="/admin/manage-schedule" element={<ManageSchedule />} />
    <Route path="/admin/course-starting" element={<CourseStarting />} />
    <Route path="/admin/e-transfer-confirmation" element={<Etransfer />} />
    <Route path="/admin/e-transfer-confirmation/view/:transferId" element={<ViewRecord />} />
    <Route path="/admin/manage-blogs" element={<VLIBlogManagement />} />
    <Route path="/admin/create-vli-blogs" element={<CreateVLIBlogs />} />
    <Route path="/admin/view-vli-blogs" element={<ViewVLIBlogs />} />
    <Route path="/admin/adadcourse" element={<ManageStatusChild />} />
    <Route path="/admin/course/update/:CoursePK" element={<UpdateCourseAdmin />} />
    <Route path="/admin/course/add" element={<AddCourseAdmin />} />
    <Route path="/admin/Book/add" element={<AddBookAdmin />} />
    <Route path="/admin/books/list" element={<EbookList />} />
    <Route path="/admin/site-analytics" element={<WebsiteAnalytics />} />
  </React.Fragment>
);
// const VLIAdminRoutes = () => {

//   return (
//     <Routes>
//       <Route path="/admin/dashboard" element={<AdminNewDashboard />} />
//       <Route path="/admin/published-courses" element={<PublishedCoursesAdmin />} />
//       <Route path="/admin/published-courses/view/:CoursePK" element={<ViewCourseAdmin />} />
//       <Route path="/admin/published-courses/edit/:CoursePK" element={<EditCourseAdmin />} />
//       <Route path="/admin/course/create" element={<CreateCourseAdmin />} />
//       <Route path="/admin/manage-partners" element={<ManagePartnersAdmin />} />
//       <Route path="/admin/delegate-institute-management" element={<AllDelegateInstitutes />} />
//       <Route path="/admin/delegate-management" element={<DelegateManagements />} />
//       <Route path="/admin/manage-partners/view/:InstituteId" element={<ViewInstituteDetails />} />
//       <Route path="/admin/manage-partners/approved/:instituteId" element={<ApprovedInstitute />} />
//       <Route path="/admin/manage-partners/approved/:instituteId/institute-data" element={<InstituteData />} />
//       <Route path="/admin/manage-partners/approved/:instituteId/request-plan" element={<RequestPlan />} />
//       <Route path="/admin/manage-partners/approved/:instituteId/class-recordings" element={<ClassRecordings />} />
//       <Route path="/admin/manage-partners/approved/:instituteId/view-team-member" element={<ViewTeamMember />} />
//       <Route path="/admin/manage-partners/approved/:instituteId/training-learner" element={<TrainingLearner />} />
//       <Route path="/admin/manage-partners/approved/:instituteId/institute-courses" element={<InstituteCourses />} />
//       <Route path="/admin/manage-partners/approved/:instituteId/institute-vehicles" element={<InstituteVehicles />} />
//       <Route path="/admin/packages-and-plan" element={<PackagesAndPlan />} />
//       <Route path="/admin/manage-packages" element={<Packages />} />
//       <Route path="/admin/manage-team" element={<ManageTeam />} />
//       <Route path="/admin/manage-learners" element={<ManageLearner />} />
//       <Route path="/admin/enroll-learner" element={<EnrollLearner />} />
//       <Route path="/admin/manage-schedule" element={<ManageSchedule />} />
//       <Route path="/admin/course-starting" element={<CourseStarting />} />
//       <Route path="/admin/e-transfer-confirmation" element={<Etransfer />} />
//       <Route path="/admin/e-transfer-confirmation/view/:transferId" element={<ViewRecord />} />
//       <Route path="/admin/manage-blogs" element={<VLIBlogManagement />} />
//       <Route path="/admin/create-vli-blogs" element={<CreateVLIBlogs />} />
//       <Route path="/admin/view-vli-blogs" element={<ViewVLIBlogs />} />
//       <Route path="/admin/adadcourse" element={<ManageStatusChild />} />
//       <Route path="/admin/course/update/:CoursePK" element={<UpdateCourseAdmin />}/>
//       <Route path="/admin/course/add" element={<AddCourseAdmin />} />
//       <Route path="/admin/Book/add" element={<AddBookAdmin />} />
//       <Route path="/admin/books/list" element={<EbookList />} />  

//       <Route path="/admin/site-analytics" element={<WebsiteAnalytics />} />
              
//     </Routes>
//   );
// };

export default VLIAdminRoutes;

